import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'

import {
    ContainersDamagedType,
} from '../ScenarioEditor.types'

export default ({
    containersLinkConfig,
}: {
    containersLinkConfig?: {
        path: string[],
        params: Record<string, string>,
    }
}): SkyNetTableConfig<keyof ContainersDamagedType> => {
    return {
        name: 'ContainersDamaged',
        fields: [
            {
                name: 'serialNumber',
                width: '160px',
                componentName: 'SkyNetTableLink',
                linkConfig: containersLinkConfig,
                type: TypeLink.EXTERNAL,
                size: SizeLink.S,
                labelKey: 'SERIAL_NUMBER',
            },
            {
                name: 'jypId',
                width: '160px',
                labelKey: 'JYP_NUMBER',
            },

            {
                name: 'containerTypeContainerModel',
                filterField: 'containerTypeContainerModel',
                filterType: FilterType.Array,
                width: '250px',
                labelKey: 'CONTAINER_MODEL',
            },
            {
                name: 'containerStatusEnriched',
                componentName: 'ContainerStatusEnriched',
                filterField: 'containerStatusEnriched',
                filterType: FilterType.Array,
                width: '200px',
                labelKey: 'STATUS',
            },
            {
                name: 'damageTypes',
                componentName: 'List',
                labelKey: 'DAMAGES_TO_BE_FIXED',
            },
        ],
    }
}
